// extracted by mini-css-extract-plugin
export var productImage = "_wp-0";